import { CSSObject } from '@chakra-ui/react';

export const LinkWrapper: CSSObject = {
  px: 3,
  py: 2,
  mb: 2,
  borderRadius: 'lg',
  bg: `rgba(78, 178, 255, 0.14)`,
  boxShadow:
    '0px 4px 10px 0px rgba(0, 0, 0, 0.3), 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
};
export const TextListName: CSSObject = {
  color: 'white',
  fontSize: 'md',
  fontFamily: 'Staatliches',
  fontWeight: 'normal',
  textTransform: 'uppercase',
};
export const IconSGM: CSSObject = {
  boxSize: '30px',
  display: 'block',
  mr: '2',
  color: 'beta.400',
};
export const TextSpanName = (isVS: boolean): CSSObject => ({
  color: 'white',
  ...(isVS && { color: 'alpha.400' }),
  fontFamily: 'body',
  fontSize: 'xs',
  fontWeight: 'semibold',
});
export const FlexSubTextWrapper: CSSObject = {
  color: 'beta.100',
  fontSize: '2xs',
  fontWeight: 'semibold',
  fontFamily: 'body',
  flex: 1,
};
export const IconSport: CSSObject = {
  color: 'alpha.600',
  boxSize: '30px',
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  bg: `beta.600`,
  borderRadius: 'lg',
  border: '2px solid',
  borderColor: 'alpha.500',
  p: '1',
};
export const IconChevron: CSSObject = {
  color: 'white',
  ml: '0',
  w: 4,
  h: 4,
};
export const FlexEndWrapper: CSSObject = {
  '> div': { gap: '4px' },
  mr: '1',
  '.countdown-flex, .timestamp': {
    color: 'white',
    fontSize: 'xs',
    bg: 'transparent',
  },
  svg: {
    color: 'alpha.600',
  },
};
export const SubTextIcon: CSSObject = {
  '&&': {
    color: 'whiteAlpha.400',
    boxSize: '5',
  },
};
